/* eslint-disable max-len */
import { useFormikContext } from 'formik';
// eslint-disable-next-line max-len
import { type MobilityApplicationEntrypointContextDataFragment } from '../../../../../api/fragments/MobilityApplicationEntrypointContextData';
import { type StockPublicDataFragment } from '../../../../../api/fragments/StockPublicData';
import { type MobilityKind, type PeriodPayload } from '../../../../../api/types';
import Form from '../../../../../components/fields/Form';
import BookingFields from './BookingFields';

export type BookingFormProps = {
    stock: Extract<StockPublicDataFragment, { __typename: 'MobilityStockInventory' }>;
    endpoint: MobilityApplicationEntrypointContextDataFragment;
};

export type MobilityDetail = {
    id: string;
    kind: MobilityKind;
    addon: string;
};

export type FormValues = {
    rentalPeriod: PeriodPayload;
    location: string;
    mobilityDetails: MobilityDetail[];
    startTime: string | Date;
    endTime: string | Date;
    bookingCode?: string;
};

const BookingForm = ({ stock, endpoint }: BookingFormProps) => {
    const { handleSubmit } = useFormikContext();

    return (
        <Form id="bookingForm" name="bookingForm" onSubmitCapture={handleSubmit}>
            <BookingFields endpoint={endpoint} stock={stock} />
        </Form>
    );
};

export default BookingForm;
